import { useRouter } from "next/router";

import { FiArrowLeftCircle } from "react-icons/fi";

import StaticIntlTranslator from "shared/components/atoms/StaticIntlTranslator";
import CheckStar from "shared/components/organisms/Collections/CheckStar";
import ModalCollection from "shared/components/organisms/Collections/RenderModal";

import { Centralizer, LandingTopbarContainer } from "./styles";

const LandingTopbar = ({ courseId }) => {
  const router = useRouter();

  const handleGoBack = () => router.back();

  return (
    <LandingTopbarContainer>
      <Centralizer>
        <div className="icon-plus-text">
          <button onClick={handleGoBack}>
            <FiArrowLeftCircle size={26} />
            <p>
              <StaticIntlTranslator id="common:goBack" />
            </p>
          </button>
        </div>

        <ModalCollection
          render={({ handleVisible }) => (
            <CheckStar
              type="course"
              autoContrastEnable
              entityId={courseId}
              handleVisible={handleVisible}
              className="Vico068\CourseTools\Course"
            />
          )}
        />
      </Centralizer>
    </LandingTopbarContainer>
  );
};

export default LandingTopbar;
